module.exports = __webpack_public_path__ + "bb95a55522a753d565ca4557ee53289f.png";